
import React from 'react';

import Thinwalled from './Thinwalled';
import Machinesthin from './Machinesthin';
import Disposablebox from './Disposablebox';


const Thinwalleddisp = () => {
    return (
        <div>
            <Thinwalled />
            <Machinesthin />
            <Disposablebox />

        </div>
    );
};

export default Thinwalleddisp;
